<template>
    <div class="auth-required-dlg">
        <el-dialog title="请求授权"
                   :visible="authRequiredDlgVisible"
                   :show-close="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <div class="tips">
                对不起，您当前会话已经过期，需要再次授权，点击【再次授权】将会转向授权页面，授权成功后，将继续您的操作。
            </div>
            <div class="op">
                <button class="btn btn-primary" @click="auth">再次授权</button>
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    import {mapState, mapMutations} from 'vuex'
    import LoginForm from './Login.vue'
    import au from './auth'

    export default{
        props: {

        },
        computed: {
            ...mapState([
                'authRequiredDlgVisible',
            ])
        },
        data(){
            return {
            }
        },
        methods: {
            ...mapMutations([
                'showAuthRequiredDlg' // 映射 this.increment() 为 this.$store.commit('increment')
            ]),
            auth(){
                this.$layer.dialog({
                    title: '登录',
                    component: LoginForm,
                    width:'400px',
                    data:{
                        isInDialog: true
                    },
                    confirm: (result) => {
                        this.showAuthRequiredDlg(false)

                        au.authOK()
                    }
                })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .auth-required-dlg {
        .el-dialog__body{
            padding:20px;

            .tips{
                text-indent: 2em;
            }
            .op{
                padding: 20px 0;
                text-align: center;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/modules/account/AuthRequiredDlg.vue